import { request } from '@umijs/max';

/**
 * 获取认证状态
 */
export async function getVerificationStatus() {
  return request<MIAOYING.Response<MIAOYING.AccountVerification>>('/api/web/verification/status', {
    method: 'GET',
  });
}

/**
 * 提交个人认证
 */
export async function submitPersonalVerification(params: MIAOYING.SubmitPersonalVerificationParams) {
  return request<MIAOYING.Response<{ id: number }>>('/api/web/verification/personal', {
    method: 'POST',
    data: params,
  });
}

/**
 * 提交企业认证
 */
export async function submitEnterpriseVerification(params: MIAOYING.SubmitEnterpriseVerificationParams) {
  return request<MIAOYING.Response<{ id: number }>>('/api/web/verification/enterprise', {
    method: 'POST',
    data: params,
  });
}
